<template>
   <div id="servicios">
      <div class="dvTitle">
         <slot name="title"></slot>
      </div>
      <div class="dvContenido">
         <slot name="contenido"></slot>
      </div>
   </div>
</template>

<script>
   export default {
      name: "Servicio"
   }
</script>

<style scoped lang="scss">
   @import "../../style/base";

   #servicios {
      padding: 25px;
      @include flexColumn;
      @include absoluteCenter;
      line-height: 1.3;

      & .dvTitle {
         @include fontFormat(32px, 600, $colorSecundary);
      }

      & .dvContenido {
         padding: 20px;
         @include Montserrat;
         @include fontFormat(18px, 400, #3c3f40);

         & .resumen {
            @include flexRow;


            & > span {
               @include fontFormat(26px, 600, #000000);
            }
            & > img {
               height: 180px;
            }
         }
      }
   }

</style>